// extracted by mini-css-extract-plugin
module.exports = {"appDownload":"app_appDownload__2y5c6"};